
import './add-company.styles.scss';
import React from 'react'
import { connect } from "react-redux";
import { Form } from '../../../controls/useForm';
import useForm from '../../../../formData/useForm';
import validate from '../../../../formData/validate';
import { ToastContainer } from 'react-toastify';
import Input from '../../../controls/Input/InputCompnent';
import Select from '../../../controls/Input/Select';
import Avatar from '../../../../assets/images/avatar.png';
import '../../../controls/Input/form.styles.scss';
import 'react-toastify/dist/ReactToastify.css';
import Button from 'react-bootstrap/Button';





const initialState = {
    companyname: {
        value: '',
        required: true
    },
    cacnumber: {
        value: '',
        required: true
    },
    address: {
        value: '',
        required: true
    },
    city: {
        value: '',
        required: true
    },
    country: {
        value: '',
        required: true
    },
    address2: {
        value: '',
        required: false
    },
    phone: {
        value: '',
        required: true
    },
    address: {
        value: '',
        required: true
    },
    industry: {
        value: '',
        required: true
    },
   
}








export const AddCompanyCompnent = ({ AddCompany, AddCacNumber,buttonloader, userId, industries, firstName, countries ,cacNumber}) => {


    function GetCountries() {
        var countries2 = []
        var old_countries = countries;
        for (var i = 0; i < old_countries.length; i++) {
            countries2.push({
                label: old_countries[i].title,
                value: old_countries[i].id
            })
        }
        return countries2;
    }
    var userDetails = null;
    const { formData, errors, changeHandler, setErrors } = useForm(initialState, validate);
    const submitHandler = (e) => {
        e.preventDefault();
        let formErrors = validate(formData, true);
        var result = { ...formErrors, "confirmpassword": "Password not equal with confirm password" }
        setErrors(result);
        //  const datas = new FormData();
        if (Object.keys(formErrors).length === 0) {
            const data = new FormData();
            for (let pair of data.entries()) {

            }
            var companyDetails = {
                companyname: formData.companyname.value,
                cacnumber: formData.cacnumber.value,
                address: formData.address.value,
                address2: formData.address2.value,
                country: formData.country.value,
                phone: formData.phone.value,
                city: formData.city.value,
                industryId: formData.industry.value,
                userId: userId
            }
            AddCacNumber(companyDetails.cacnumber)
            AddCompany(companyDetails)
        }

    }

    return (
        <div className='add-company'>
            <div className='w-full justify-center flex flex-col items-center'>
                <img src={Avatar} alt="avatar" className='avatar cursor-pointer' />
                <h3>Hi <strong>{firstName}</strong></h3>
                <p className="mb-3"> <strong>Thank you </strong>for registering, Kindly fill in your <strong>company's</strong> details to proceed</p>
            </div>
            <div className='second-card p-4 mb-4'>
                <ToastContainer />
                <h4 className="text-primary text-center pt-2 pb-3"> <strong>Company's Information </strong> </h4>
                <Form onSubmit={submitHandler}>
                    <Input
                        // label="Company Name"
                        name="companyname"
                        placeholder="Name of Company"
                        id="companyname"
                        value={formData.companyname.value}
                        onChange={changeHandler}
                        error={errors.companyname}
                    />

                    <Select
                        label="Industry"
                        name="industry"
                        id="industry"
                        options={industries}
                        value={formData.industry.value}
                        onChange={changeHandler}
                        error={errors.industry}
                    />
                    <Input
                        label="Telephone"
                        name="phone"
                        placeholder="Telephone"
                        id="phone"
                        value={formData.phone.value}
                        onChange={changeHandler}
                        error={errors.phone}
                    />
                    <Input
                        label="Address Line 1"
                        name="address"
                        placeholder="Address"
                        id="address"
                        value={formData.address.value}
                        onChange={changeHandler}
                        error={errors.address}
                    />

                    <Input
                        label="Address Line 2"
                        name="address2"
                        placeholder="Address"
                        id="address2"
                        value={formData.address2.value}
                        onChange={changeHandler}
                    />
                    <Select
                        label="Country"
                        name="country"
                        id="countries"
                        options={GetCountries()}
                        value={formData.country.value}
                        onChange={changeHandler}
                        error={errors.country}
                    />

                    <Input
                        label="City"
                        name="city"
                        placeholder="City"
                        id="city"
                        value={formData.city.value}
                        onChange={changeHandler}
                        error={errors.city}
                    />
                    <Input
                        label="CAC Number"
                        name="cacnumber"
                        placeholder="Cac Number"
                        id="cacumber"
                        value={formData.cacnumber.value}
                        onChange={changeHandler}
                        error={errors.cacnumber}
                    />
                    <div className="text-center mb-3">
                        <Button type="submit" className="save-button" variant="primary">Save & Continue <i class={buttonloader === true ? "fa fa-spinner fa-spin" : ''}></i></Button>{' '}
                    </div>
                </Form>
            </div>
        </div>

    )
}



function mapStateToProps(state) {
    return {
        buttonloader: state.utilityReducer.buttonloader,
        user: state.userReducer.user,
        userId: state.userReducer.userId,
        countries: state.persistReducer.countries,
        firstName: state.userReducer.firstName,
        cacNumber:state.persistReducer.cacNumber,
        industries: state.userReducer.industries,
    };
}
const mapDispatchToProps = (dispatch) => ({

    AddCompany(payload) {
        dispatch({ type: "ADD_COMPANY", payload });
    },
    AddCacNumber(payload) {
        dispatch({ type: "PERSIST_CAC_NUMBER", payload });
    },
    SetError() {
        dispatch({ type: "API_ERRORED" });
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddCompanyCompnent);

